<template>
    <basic-table
        show-top-button="true"
        @top-button-click="createUserOpenModal"
    >
        <template v-slot:table_cards_header>
            <h5>Users List</h5>
        </template>
        <template v-slot:table_rows_header>
            <tr class="border-bottom-primary">
                <th scope="col">Id</th>
                <th scope="col">Username</th>
                <th scope="col">Role</th>
                <th scope="col">Specialization</th>
                <th scope="col">Name</th>
                <th scope="col">actions</th>
            </tr>
        </template>
        <template v-slot:table_rows_data>
            <tr v-if="users === null">
                <td colspan="5" class="text-center">Empty table</td>
            </tr>
            <tr v-else v-for="(user, index) in users" :key="user.id">
                <td>{{ user.id }}</td>
                <td>{{ user.username }}</td>
                <td>{{ user.roles.map(role => role.name).join(', ') }}</td>
                <td>{{ user.specialization ? user.specialization.name : '' }}</td>
                <td>{{ user.name }}</td>
                <td>
                    <ul class="action">
                        <li class="edit">
                            <a @click="setUserItemData(user, index)" data-bs-toggle="modal" data-bs-target="#edit-modal" href="#">
                                <i class="icon-pencil-alt"></i>
                            </a>
                        </li>
                        <li class="delete">
                            <a @click="openDeleteModal(user)" href="#">
                                <i class="icon-trash"></i>
                            </a>
                        </li>
                    </ul>
                </td>
            </tr>
        </template>
    </basic-table>
    <basic-modal
        title="Edit User"
        target-id="edit-modal"
        set-class="modal-lg"
        @close="clearUserModalForm"
        @shown="userFormOnOpen"
        @closeModal="closeEditModal"
    >
        <template v-slot:modal_body>
            <create-user
                ref="userForm"
                :is-edit="modalUserIsEditMode"
                :user="userItem"
                :show-buttons="false"
                @stored="handleUserStored"
                @closeModal="closeEditModal"
            />
        </template>
        <template v-slot:first_button>
            <button @click="saveUserData" class="btn btn-outline-info">{{ modalUserIsEditMode ? 'Save' : 'Add User' }}</button>
        </template>
    </basic-modal>
    <confirm-modal
        modal-id="deleteUserConfirmModal"
        title="Confirm Deletion"
        :message="`Are you sure you want to delete user '${userToDelete?.username}'?`"
        @confirm="confirmDeleteUser"
    />
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
const toaster = createToaster({})

import BasicTable from "../Basic/BasicTable.vue";
import BasicModal from "../Basic/BasicModal.vue";
import ConfirmModal from "../Basic/ConfirmModal.vue";

import CreateUser from "./CreateUser.vue";

export default {
    name: 'UsersList',
    data() {
        return {
            users: null,
            deleteUserIdItem: null,
            userItem: {},
            deleteMessage: '',
            modalUserIsEditMode: false,
            userToDelete: null,
        };
    },
    components: {
        ConfirmModal,
        BasicTable,
        BasicModal,
        CreateUser,
    },
    methods: {
        closeEditModal() {
            $('#edit-modal').modal('hide');
        },

        createUserOpenModal: function () {
            this.modalUserIsEditMode = false;

            $('#edit-modal').modal('show');
        },

        fetchAll: function () {
            let $this = this;

            axios.get('/api/users/list/get', {})
                .then(function (response) {
                    $this.users = response.data.items;
                })
        },

        setUserItemData: function (user, index) {
            this.modalUserIsEditMode = true;
            this.deleteUserIdItem = index;

            this.userItem = Object.create(user);

            this.deleteMessage = 'Are you sure, that you want to delete "' + user.username + '" ?';
        },

        saveUserData: function() {
            this.$refs.userForm.store();
        },

        handleUserStored: function () {
            this.fetchAll();
        },

        clearUserModalForm: function() {
            this.$refs.userForm.clearForm();
        },

        userFormOnOpen: function() {
            //this.$refs.userForm.onOpen();
        },

        openDeleteModal(user) {
            this.userToDelete = user;

            $('#deleteUserConfirmModal').modal('show');
        },

        confirmDeleteUser() {
            if (!this.userToDelete) return;

            axios
                .delete(`/api/users/${this.userToDelete.id}`)
                .then(() => {
                    this.showToastSuccessMessage('User deleted successfully');
                    this.users = this.users.filter(user => user.id !== this.userToDelete.id);

                    this.userToDelete = null;
                })
                .catch(error => {
                    console.error('Failed to delete user:', error);
                    this.showToastErrorMessage('Failed to delete user. Please try again.');
                })
                .finally(() => {
                    $('#deleteUserConfirmModal').modal('hide');
                });
        },

        showToastErrorMessage(message) {
            toaster.show('Oops... ' + message, {
                theme: 'outline',
                position: 'top-right',
                icon: 'times',
                type: 'error',
                duration: 2000,
            });
        },
        showToastSuccessMessage(message) {
            toaster.show(message, {
                theme: 'outline',
                position: 'top-right',
                icon: 'check',
                type: 'success',
                duration: 2000,
            });
        },
    },
    mounted() {
        this.fetchAll();
    },
}
</script>
